module.exports = __webpack_public_path__ + "img/airplane-pin.989a3d50.svg";